import { createAction, props } from "@ngrx/store";
import { AchInquiryResponse } from "../../create-request/models/ach/AchInquiryResponse";
import { ServiceError, ServiceErrorWithList } from "../../create-request/models/shared/ServiceError";
import { StandingInstruction } from "../../shared/types/StandingInstruction";
import { CashieringTransaction, RecurringTransaction } from "../../create-request/models";
import { ViewTypes, transactionTypes } from "../../shared/utilities/Constants";
import { AchVerifyApiResponse } from "../../create-request/models/ach/AchVerifyApiResponse";
import { StandingAuthorizationForm } from "../models/standingAuthorizationForm";
import { AchAcknowledgeApiResponse } from "../../create-request/models/ach/AchAcknowledgeApiResponse";


export const callAchInquiry = createAction(
    '[Standing Auth - ACH] Call to ACH inquiry',
    props<{ payload: StandingInstruction | CashieringTransaction | RecurringTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const inquiryCallSuccessful = createAction(
    '[Standing Auth - ACH] Call to ACH inquiry was successful ',
    props<{ achInquiryResponse: AchInquiryResponse }>()
);

export const inquiryCallFailed = createAction(
    '[Standing Auth - ACH] Call to ACH inquiry failed',
    props<ServiceError>()
);

export const callAchVerify = createAction(
    '[Create Standing Authorization - Standing Auth Form] Call ach verify',
    props<StandingAuthorizationForm>()
);

export const verifyCallSuccessful = createAction(
    '[Standing Auth - ACH] Call to verify was successful',
    props<{response: AchVerifyApiResponse, initiationDate: string}>()
);

export const verifyCallFailed = createAction(
    '[Standing Auth - ACH] Error calling verify',
    props<ServiceError>()
);

export const verifyCallFinishedWithError = createAction(
    '[Standing Auth - ACH] Verify call has error',
    props<{ response: AchVerifyApiResponse }>()
);

export const callAcknowledge = createAction(
    '[Standing Auth - ACH] Call to ACH acknowledge'
);

export const acknowledgeCallSuccessful = createAction(
    '[Standing Auth - ACH] Call to ACH acknowledge was successful',
    props<{ response: AchAcknowledgeApiResponse }>()
);

export const acknowledgeCallFail = createAction(
    '[Standing Auth - ACH] Call to ACH acknowledge failed',
    props<ServiceErrorWithList>()
);

export const acknowledgeCallFinishedWithError = createAction(
    '[Standing Auth - ACH] Acknowledge call has error',
    props<{ response: AchAcknowledgeApiResponse }>()
);
